import { ReactNode } from 'react';
import store from '@/store';
import { history } from 'ice';
import { CustomRouteItem } from '@/interfaces/breadcrumbs';
import { Breadcrumb, Icon } from '@b-design/fusion';
import './index.less';
import $i18n from '../../i18n';

interface CommonHeaderProps {
  title: string;
  titleRender?: () => ReactNode;
  backTo?: string;
  breadcrumbs?: CustomRouteItem[];
  icon?: string;
  goBack?: boolean;
}

const CommonHeader = (props: CommonHeaderProps) => {
  const [spaceRoleState] = store.useModel('spaceRole');
  const { title, titleRender, breadcrumbs = [], backTo, icon, goBack } = props;

  const renderItem = (config: CustomRouteItem) => {
    return (
      <Breadcrumb.Item
        className="breadcrumb-item"
        key={config.key}
        onClick={() => {
          if (config.path) history?.push(`${config.path}?${location.hash?.split('?')?.[1] || ''}`);
        }}
      >
        {config.breadcrumbName}
      </Breadcrumb.Item>
    );
  };

  const renderTitle = () => {
    if (titleRender) {
      return titleRender();
    }

    if (goBack) {
      return (
        <div className="common-title ">
          <Icon
            className="backable"
            onClick={() => {
              window.history?.back();
            }}
            size="xl"
            type="arrow--left"
          />
          <span>{title}</span>
        </div>
      );
    }

    if (backTo) {
      return (
        <div className="common-title ">
          <Icon
            className="backable"
            onClick={() => {
              history?.push(backTo);
            }}
            size="xl"
            type="arrow--left"
          />
          {icon ? (
            <img
              src={icon}
              alt=""
              style={{ width: 28, height: 28, marginRight: 10, borderRadius: 4 }}
            />
          ) : null}
          <span>{title}</span>
        </div>
      );
    }

    return <div className="common-title">{title}</div>;
  };

  return (
    <div className="common-header">
      {breadcrumbs?.length ? (
        <Breadcrumb className="breadcrumb-group">
          <Breadcrumb.Item
            className="breadcrumb-item"
            key={'root'}
            onClick={() => {
              const _roleList = spaceRoleState?.roleList || [];
              if (_roleList?.length === 1 && _roleList?.includes('AIGC_DESIGNER')) {
                return;
              }
              history?.push(`/overview?${location.hash?.split('?')?.[1] || ''}`);
            }}
          >
            {$i18n.get({ id: 'aopf.components.CommonHeader.Workspace', dm: '工作空间' })}
          </Breadcrumb.Item>
          {breadcrumbs.map((config) => renderItem(config))}
        </Breadcrumb>
      ) : null}
      {renderTitle()}
    </div>
  );
};

export default CommonHeader;
